import { memo, useContext } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { generateDestinationTitle } from "app/utils/productUtils";
import AppGlobalsContext from "app/AppGlobalsContext";
import LocationModal from "app/pages/.shared/LocationModal/LocationModal";
import { PRODUCT_PAGE_CODE_STATUS } from "app/constants";
import Skeleton from "react-loading-skeleton";
import ProductNameWithCategory from "app/pages/.shared/ProductNameWithCategory/ProductNameWithCategory";
import classNames from "classnames";

const SKELETON_HIGHLIGHT_COLOR = "#cdcdcd";

const ProductAddress = ({ ficheProduit = {}, className }) => {
	const { shop } = useContext(AppGlobalsContext);
	return (
		<div className={classNames("product-address", className)}>
			{ficheProduit?.status !== PRODUCT_PAGE_CODE_STATUS.SUCCESS ? (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.REGULAR}
					className="product-address__label"
					data-testid="product-address__location"
					style={{ display: "flex" }}
				>
					<Skeleton
						highlightColor={SKELETON_HIGHLIGHT_COLOR}
						height={13}
						borderRadius={17}
						width={96}
						containerClassName="product-address__skeleton"
					/>
					, {generateDestinationTitle(shop, ficheProduit, false)}
				</Typography>
			) : (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.REGULAR}
					className="product-address__label"
					data-testid="product-address__location"
					component="address"
				>
					{[
						...(ficheProduit?.address?.address1
							? [ficheProduit?.address.address1?.trim()]
							: []),
						generateDestinationTitle(shop, ficheProduit, false),
					]
						.filter(Boolean)
						.join(", ")}
				</Typography>
			)}

			<LocationModal
				lat={ficheProduit?.gps?.lat}
				lon={ficheProduit?.gps?.lon}
				title={
					<ProductNameWithCategory
						categoryType={ficheProduit.categoryType}
						category={ficheProduit.category}
						name={ficheProduit.name}
					/>
				}
				labelCta={<FormattedMessage id="sdp.product.view.map.label" />}
			/>
		</div>
	);
};

ProductAddress.propTypes = {
	ficheProduit: PropTypes.object,
};

export default memo(ProductAddress);
